import Option from '@/components/form/types/Option.ts';
import { FillerType } from '@/features/public/booking/types/FillerType.ts';

const FILLER_TYPE_LABELS: Record<FillerType, string> = {
  [FillerType.CLIENT]: 'Osoba nie biorąca udziału',
  [FillerType.PARTICIPANT]: 'Uczestnik',
};

export const getFillerTypeLabel = (fillerType: FillerType): string =>
  FILLER_TYPE_LABELS[fillerType];

/** Kolejność przełącznika: rezerwacja „dla kogoś” jest przypadkiem częstszym. */
export const FILLER_TYPE_OPTIONS: Option[] = [
  { label: FILLER_TYPE_LABELS[FillerType.CLIENT], value: FillerType.CLIENT },
  {
    label: FILLER_TYPE_LABELS[FillerType.PARTICIPANT],
    value: FillerType.PARTICIPANT,
  },
];
